/**
 * `onPointerDownOutside` guard for `@akademi/ui`'s Radix-based `Dialog`.
 *
 * `SbSelect` (and `Pagination`'s page-size dropdown, which is built on
 * it) portals its listbox straight to `document.body` via
 * `createPortal`, tagged with `data-sb-select-portal` — outside any
 * Dialog's own content subtree. `@akademi/ui`'s `AsyncSelect`/`Combobox`
 * (`@base-ui/react`-based) does the same thing via its own
 * `Combobox.Portal`, landing on a popup tagged `data-slot="combobox-
 * content"`. Radix's Dialog treats a pointerdown outside its content
 * subtree as a request to close — and detects it on a document-level
 * capture listener that runs *before* the option's own click handler —
 * so without this guard, clicking an option in either dropdown while a
 * Dialog is open closes the Dialog before the click can register. Pass
 * this to `DialogContent`'s `onPointerDownOutside` prop wherever it
 * might render an `SbSelect`, `AsyncSelect`, `SelectField`/`Combobox`,
 * or `Pagination`, directly or through a child component.
 */
export function ignoreSbSelectPortalOutsideClick(event: {
  target: EventTarget | null;
  preventDefault: () => void;
}) {
  if (
    event.target instanceof Element &&
    (event.target.closest('[data-sb-select-portal]') ||
      event.target.closest('[data-slot="combobox-content"]'))
  ) {
    event.preventDefault();
  }
}
